import { createAction, props, union } from '@ngrx/store';

import { Vehicle } from '@global/infrastructure/interfaces/vehicle';

export const carLookupSuccess = createAction(
  '[YourCar] Car Lookup Success',
  props<{ newVehicle: Vehicle }>()
);

export const updateCarDetails = createAction(
  '[YourCar] Update Car Details',
  props<{ updatedCarDetails: any}>()
);

export const resetCar = createAction(
  '[YourCar] Reset Car'
);

export const resetAll = createAction(
  '[YourCar] Reset All'
);

export const resetError = createAction(
  '[YourCar] Reset Error'
);

const all = union({
  carLookupSuccess,
  updateCarDetails,
  resetCar,
  resetAll,
  resetError
});

export type YourCarActionsUnion = typeof all;

